module.exports = __webpack_public_path__ + "img/neosurf.a6794a9c.svg";